module.exports = __webpack_public_path__ + "33fd175bbfd87c9103c69f605f9326b7.pdf";